<template>
  <div class="view-held-charge">
    <div class="row">
      <div class="col-md-8">
        <p>
          <strong>Member:</strong>
          <router-link :to="'/membership/members/' + heldCharge.Account.uuid">
            {{ heldCharge.Account.dropdownLabel }}
          </router-link>
        </p>
        <div class="callout callout-warning">
          <span v-if="!refunded">
            Charge will be captured / released on: {{ captureDate | short_date_format }}
          </span>
          <span v-else>
            This PreAuthorisation has been refunded / captured.
          </span>
        </div>
      </div>
    </div>
    <div class="row" v-if="!refunded">
      <div class="col-md-8">
        <div class="toolbar pull-right">
          <button class="btn btn-default" @click="addCharge()">
            <span class="fa fa-dollar-sign fa-fw"></span> Add Charge
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <div class="row">
          <div class="col-sm-12">
            <div class="box box-primary" v-if="heldCharge.ReservationCharges.length > 0 || heldCharge.BulkCharges.length > 0">
              <div class="box-header">
                <h1 class="box-title">Charges</h1>
              </div>
              <div class="billing-table">
                <div class="row billing-headings row-eq-height">
                  <div class="col-xs-6 rt-cell">
                    Description
                  </div>
                  <div class="col-xs-6 last-rt-cell rt-cell">
                    Amount
                  </div>
                </div>
                <div v-for="charge in heldCharge.ReservationCharges" class="row-eq-height row billing-item" :key="charge.uuid">
                  <div class="col-xs-6 rt-cell">
                    <router-link :to="'/fleet/reservations/' + charge.ReservationUuid">
                      {{ charge.description }}
                    </router-link>
                  </div>
                  <div class="col-xs-4 rt-cell">
                    {{ charge.cost | to_dollar_amount }}
                  </div>
                  <div class="col-xs-2 rt-cell last-rt-cell">
                    <button class="btn btn-info btn-xs" @click="refundPending(charge, 'ReservationCharge')">
                      <span class="fa fa-exchange-alt"></span> Refund
                    </button>
                  </div>
                </div>
                <div v-for="charge in heldCharge.BulkCharges" class="row-eq-height row billing-item" :key="charge.uuid">
                  <div class="col-xs-6 rt-cell">
                    <router-link :to="'/membership/members/bulkcharge/?charge=' + charge.uuid + '&note=' + charge.AccountNoteUuid">
                      {{ charge.description }}
                    </router-link>
                  </div>
                  <div class="col-xs-4 rt-cell">
                    {{ charge.cost | to_dollar_amount }}
                  </div>
                  <div class="col-xs-2 rt-cell last-rt-cell">
                    <button class="btn btn-info btn-xs" @click="refundPending(charge, 'BulkCharge')">
                      <span class="fa fa-exchange-alt"></span> Refund
                    </button>
                  </div>
                </div>
                <div class="row-eq-height row billing-item">
                  <div class="col-xs-6 rt-cell">
                    <strong>Total</strong>
                  </div>
                  <div class="col-xs-6 rt-cell last-rt-cell">
                    {{ heldCharge.captureAmount | to_dollar_amount }}
                  </div>
                </div>
              </div>
            </div>
            <div class="box box-primary">
              <div class="box-header">
                <h1 class="box-title">Totals</h1>
              </div>
              <div class="billing-table">
                <div class="row billing-headings row-eq-height">
                  <div class="col-xs-6 rt-cell">
                    Description
                  </div>
                  <div class="col-xs-6 rt-cell last-rt-cell">
                    Amount
                  </div>
                </div>
                <div class="row-eq-height row billing-item">
                  <div class="col-xs-6 rt-cell">
                    Amount Held
                  </div>
                  <div class="col-xs-4 rt-cell">
                    {{ heldCharge.cost | to_dollar_amount }}
                  </div>
                  <div class="col-xs-2 rt-cell last-rt-cell">
                    <button class="btn btn-danger btn-xs" v-if="!refunded" @click="release()"><span class="fa fa-exclamation-triangle"></span> Refund All</button>
                  </div>
                </div>
                <div class="row-eq-height row billing-item">
                  <div class="col-xs-6 rt-cell">
                    Total {{ refunded ? '' : 'to be' }} captured
                  </div>
                  <div class="col-xs-4 rt-cell">
                    {{ heldCharge.captureAmount | to_dollar_amount }}
                  </div>
                  <div class="col-xs-2 rt-cell last-rt-cell">
                    <button v-if="heldCharge.captureAmount > 0 && !refunded" class="btn btn-warning btn-xs" @click="capture()"><span class="fa fa-hand-rock"></span> Capture Now</button>
                  </div>
                </div>
                <div class="row-eq-height row billing-item">
                  <div class="col-xs-6 rt-cell">
                    Total {{ refunded ? '' : 'to be' }} released {{ refunded ? '' : '(available to capture)' }}
                  </div>
                  <div class="col-xs-6 rt-cell last-rt-cell">
                    {{ heldCharge.cost - heldCharge.captureAmount | to_dollar_amount }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResponsiveTable from '../ResponsiveTable'
import {
  CAPTURE_HELD_CHARGE,
  CREATE_PENDING_CHARGE,
  LOAD_HELD_CHARGE,
  REFUND_PENDING_CHARGE,
  RELEASE_HELD_CHARGE
} from '@/vuex/types'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ViewHeldCharge',
  components: {
    ResponsiveTable
  },
  computed: {
    heldCharge () {
      return {
        ...this.userHeldCharge,
        ...this.updatedHeldCharge
      }
    },
    ...mapGetters([
      'userHeldCharge'
    ]),
    refunded () {
      return this.heldCharge.captured
    },
    captureDate () {
      return moment(this.heldCharge.createdAt).add(6, 'days')
    }
  },
  async mounted () {
    await this.$store.dispatch(LOAD_HELD_CHARGE, this.$route.params.heldChargeUuid)
  },
  data () {
    return {
      updatedHeldCharge: {}
    }
  },
  methods: {
    async executeAction (action, payload) {
      let result = await this[action](payload)
      if (result && result.updated) this.updatedHeldCharge = result.updated
    },
    refundPending (charge, modelName) {
      this.executeAction(REFUND_PENDING_CHARGE, {
        ChargeUuid: charge.uuid,
        AccountUuid: this.heldCharge.Account.uuid,
        modelName
      })
    },
    release () {
      this.executeAction(RELEASE_HELD_CHARGE, {
        HeldChargeUuid: this.heldCharge.uuid,
        AccountUuid: this.heldCharge.Account.uuid
      })
    },
    capture () {
      this.executeAction(CAPTURE_HELD_CHARGE, {
        HeldChargeUuid: this.heldCharge.uuid,
        AccountUuid: this.heldCharge.Account.uuid
      })
    },
    addCharge () {
      this.executeAction(CREATE_PENDING_CHARGE, {
        HeldChargeUuid: this.heldCharge.uuid,
        AccountUuid: this.heldCharge.Account.uuid
      })
    },
    ...mapActions([
      CAPTURE_HELD_CHARGE,
      CREATE_PENDING_CHARGE,
      REFUND_PENDING_CHARGE,
      RELEASE_HELD_CHARGE
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/ViewHeldCharge.vue